import { AxiosResponse } from "axios";
import http from "utilities/http-common";

const baseUrl = "/api/tenants";

export async function getNames(): Promise<guestTenant[]> {
    return await http.get(baseUrl)
        .then((res: AxiosResponse<guestTenant[]>) => {
            return res.data;
        })
}

export async function get(id: string): Promise<guestTenant> {
    return await http.get(`${baseUrl}/${id}`)
        .then((res: AxiosResponse<guestTenant>) => {
            return res.data;
        })
}

export async function getByZone(zone: string): Promise<guestTenant> {
    return await http.get(`${baseUrl}/zone/${zone}`)
        .then((res: AxiosResponse<guestTenant>) => {
            return res.data;
        })
}

export async function getEmails(id: string): Promise<tenantEmailDto> {
    return await http.get(`${baseUrl}/${id}/emails`)
        .then((res: AxiosResponse<tenantEmailDto>) => {
            return res.data;
        })
}

export async function updateEmails(id: string, data: tenantEmailDto): Promise<void> {
    return await http.put(`${baseUrl}/${id}/emails`, data)
        .then((res: AxiosResponse<void>) => {
            return;
        })
}

export async function updateCurrentTenant(id: string, data: updateGuestTenant): Promise<guestTenant> {
    return await http.put(`${baseUrl}/${id}`, data)
        .then((res: AxiosResponse<guestTenant>) => {
            return res.data;
        })
}

export async function getConnectiveInfo(tenantId?: string): Promise<tenantConnectiveDto> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return await http.get(`${baseUrl}/connective/`, { params })
        .then((res: AxiosResponse<tenantConnectiveDto>) => {
            return res.data;
    })
}

export async function updateConnectiveInfo(tenantConnectiveDto: tenantConnectiveDto): Promise<tenantConnectiveDto> {

    return await http.put(`${baseUrl}/connective/`, tenantConnectiveDto)
        .then((res: AxiosResponse<tenantConnectiveDto>) => {
            return res.data;
    })
}

export interface guestTenant {
    id: string,
    name: string
    displayName: string
    displayNameFrench: string
    hasLogo: boolean
    manualSign: boolean
    zoneNum: string
    email: string
    tel: string
    address: string
    oneLineAddress: string
    emailBescherming: string
    defaultLanguage: string
}

export interface updateGuestTenant {
    email: string
    tel: string
    address: string
    oneLineAddress: string
    emailBescherming: string
    defaultLanguage: string
}

export interface tenantEmailDto {
    emailFrom: string
    emailInfoEmployee: string
}

export interface tenantConnectiveDto {
    id: string
    signingMethodsExternal: string
    signingMethodsInternal: string
    urlApi: string
    urlToken: string
    clientId: string
    clientSecret: string
    contactGroup: string
    defaultUser: string
    themeCode: string
    scope: string
    grantType: string
}